export function ExpandIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66602 7.99999C2.66602 7.75452 2.865 7.55554 3.11046 7.55554H12.8882C13.1337 7.55554 13.3327 7.75452 13.3327 7.99999C13.3327 8.24545 13.1337 8.44443 12.8882 8.44443H3.11046C2.865 8.44443 2.66602 8.24545 2.66602 7.99999Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99891 6.66669C7.75345 6.66669 7.55447 6.4677 7.55447 6.22224L7.55447 1.7778C7.55447 1.53233 7.75345 1.33335 7.99892 1.33335C8.24438 1.33335 8.44336 1.53233 8.44336 1.7778L8.44336 6.22224C8.44336 6.4677 8.24438 6.66669 7.99891 6.66669Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0905 3.86989C9.91698 4.04345 9.63556 4.04345 9.462 3.86989L7.99849 2.40637L6.53498 3.86989C6.36143 4.04345 6.08 4.04345 5.90645 3.86989C5.73289 3.69632 5.73289 3.41491 5.90645 3.24134L7.68423 1.46357C7.85778 1.29002 8.1392 1.29002 8.31276 1.46357L10.0905 3.24135C10.2641 3.41491 10.2641 3.69632 10.0905 3.86989Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99891 14.6667C7.75345 14.6667 7.55447 14.4677 7.55447 14.2222L7.55447 9.7778C7.55447 9.53233 7.75345 9.33335 7.99892 9.33335C8.24438 9.33335 8.44336 9.53233 8.44336 9.7778L8.44336 14.2222C8.44336 14.4677 8.24438 14.6667 7.99891 14.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.31276 14.5365C8.1392 14.7101 7.85778 14.7101 7.68423 14.5365L5.90645 12.7587C5.73289 12.5852 5.73289 12.3038 5.90645 12.1302C6.08 11.9567 6.36143 11.9567 6.53498 12.1302L7.99849 13.5937L9.462 12.1302C9.63556 11.9567 9.91698 11.9567 10.0905 12.1302C10.2641 12.3038 10.2641 12.5852 10.0905 12.7587L8.31276 14.5365Z"
        fill="currentColor"
      />
    </svg>
  );
}
